import {call, put, select, take} from "redux-saga/effects";
import {getType} from "typesafe-actions";
import {trackError} from "../../log/actions";
import apiCall from "../../../shared/utils/apiCall";
import {gameInit, gameReset} from "../actions";
import {exportStateFlow} from "../stateFlowEnhancer";
import {LogLevel} from "../../log/types";
import {IApplicationState} from "../../index";
import {showConfirmationDialog} from "../../dialog-manager/dialogs/showConfirmationDialog";
import i18n from "../../../shared/i18n";

export default function* resetStateWorker() {
    yield take(getType(gameInit));

    const allowDebug = yield select(({settings}: IApplicationState) => settings.allowDebug);
    if (!allowDebug)
        return;

    while (true) {
        yield take(getType(gameReset));

        const isConfirmed = yield call(showConfirmationDialog, i18n("settings.resetprogressconfirmation"));
        if (!isConfirmed)
            return;

        try {
            localStorage.removeItem('ql::playerid');
        }
        catch (_) {}

        try {
            yield call(apiCall, {
                params: {
                    section: "user",
                    method: "reset",
                },
            });

            const {appVersion, userId} = yield select(({ player, settings }: IApplicationState) => ({
                appVersion: settings.appVersion,
                userId: settings.userId || "fb_" + player.id,
            }));

            const flow = yield call(exportStateFlow);

            yield apiCall({
                params: {
                    section: "log",
                    method: "post",
                },
                data: {
                    messages: [{
                        logLevel: LogLevel.Warn,
                        category: "ResetState",
                        message: `User #${userId} reset progress`,
                        data: {
                            appVersion: appVersion,
                            userId: userId,
                            clientTime: new Date().getTime(),
                            state: flow,
                        }
                    }]
                }
            });

            document.location.reload();
        }
        catch (error) {
            yield put(trackError({
                category: "ResetState",
                message: "Failed to post user progress",
                error: error,
            }));
        }
    }
}